import { render, staticRenderFns } from "./TaxReportLandlordSummary.vue?vue&type=template&id=62d88530&scoped=true&"
import script from "./TaxReportLandlordSummary.vue?vue&type=script&lang=js&"
export * from "./TaxReportLandlordSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d88530",
  null
  
)

export default component.exports